import { useState, useEffect } from "react";
import "@styles/pages/Home/HomeKv.scss";
import FadeSwiper from "@components/ui/FadeSwiper";
import { Trans, useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { getLandingKV } from "@api/landingApi";
const HomeKv = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const [apiLandingKV, setApiLandingKV] = useState(null);
  const [landingSlides, setLandingSlides] = useState([]);

  useEffect(() => {
    const fetchLandingKV = async () => {
      try {
        const res = await getLandingKV();
        console.log(res.data);
        setApiLandingKV(res.data.Data); // 直接 save Data array
      } catch (err) {
        console.error("getLandingKV error", err);
      }
    };
    fetchLandingKV();
  }, []);

  useEffect(() => {
    if (apiLandingKV) {
      const mappedSlides = mapLandingKV(apiLandingKV, currentLang);
      setLandingSlides(mappedSlides);
    }
  }, [currentLang, apiLandingKV]);

  return (
    <Box className="kv-container">
      <FadeSwiper slides={landingSlides} />
    </Box>
  );
};

const mapLandingKV = (apiData, lang) => {
  if (!apiData?.length) return [];
  console.log(apiData);
  return apiData
    .sort((a, b) => b.display_order - a.display_order)
    .map((item) => ({
      image_desktop:
        lang === "hk" ? item.desktop_img_hk : item.desktop_img_hk_en,
      image_mobile: lang === "hk" ? item.mobile_hk : item.mobile_hk_en,
      url: (lang === "hk" ? item.url_hk : item.url_hk_en) || "",
      description: "",
      join_btn: lang === "hk" ? item.join_btn : item.join_btn,
    }));
};

export default HomeKv;
